(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialIbqDialogController', MaterialIbqDialogController);

    MaterialIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Material', 'MaterialFile', 'Type', 'Publisher', 'Person', 'PortalRole'];

    function MaterialIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Material, MaterialFile, Type, Publisher, Person, PortalRole) {
        var vm = this;

        vm.material = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.materialfiles = MaterialFile.query();
        vm.types = Type.query();
        vm.publishers = Publisher.query();
        vm.people = Person.query();
        vm.portalroles = PortalRole.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.material.id !== null) {
                Material.update(vm.material, onSaveSuccess, onSaveError);
            } else {
                Material.save(vm.material, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:materialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setCoverFile = function ($file, material) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        material.coverFile = base64Data;
                        material.coverFileContentType = $file.type;
                        material.coverPath = $file.name;
                    });
                });
            }
        };

    }
})();
